// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/angular2-calendar.scss
// module id = 20
// module chunks = 0